<div *ngIf="branding" class="bg-light">
  <div class="dashboard-container flex justify-center bg-neutral-50" *ngIf="!showBasicForm && !showForm && status">
    <div class="grid-row mobile:px-5 tablet:px-6 laptop:w-912 desktop:px-0 py-5">
      <div class="col-span-12">
        <div class="tablet:flex items-center">
          <div>
            <h1 class="greeting font-semibold pb-2 mb-2 mt-6">Good {{getTimeOfDay()}} {{status.refereeFirstName}}</h1>
            <p class="text-neutral-700 text-4">
              <strong class="text-4 font-medium">{{status.applicantName}}</strong> has applied for the role of {{status.jobTitle}} at {{status.clientName}} and indicated that you may be willing to provide us with a {{status.referenceType.toLowerCase()}} reference. A prompt response would be greatly appreciated.
            </p>
          </div>
          <div class="tablet:ml-6 flex-100 searching-icon">
            <img src="assets/searching.svg" alt="Protecting your information" class="w-130" />
          </div>
        </div>
        <div class="referee-card mt-8 border-info-200">
          <div class="border-neutral-100 p-7 grid-row">
            <div class="col-span-12 tablet:col-span-4 laptop:col-span-3 desktop:col-span-3 p-6 border-l-1 border-neutral-100" *ngIf="status.referenceType === 'Professional'">
              <i class="fak fa-talos-user text-neutral-400 text-6"></i>
              <div class="mt-2 text-neutral-500 text-3">Position Held</div>
              <div class="mt-1 text-4 font-medium text-dark">{{status.applicantPosition}}</div>
            </div>
            <div class="col-span-12 tablet:col-span-4 laptop:col-span-3 desktop:col-span-3 p-6 border-l-1 border-neutral-100" *ngIf="status.referenceType === 'Professional'">
              <i class="fak fa-talos-building text-neutral-400 text-6"></i>
              <div class="mt-2 text-neutral-500 text-3">Organisation</div>
              <div class="mt-1 text-4 font-medium text-dark">{{status.organisationName}}</div>
            </div>
            <div class="col-span-12 tablet:col-span-4 laptop:col-span-3 desktop:col-span-3 p-6 border-l-1 border-neutral-100" *ngIf="status.referenceType === 'Professional'">
              <i class="fak fa-talos-calendar-alt text-neutral-400 text-6"></i>
              <div class="mt-2 text-neutral-500 text-3">Employment Dates</div>
              <div class="mt-1 text-4 font-medium text-dark">{{status.employmentDates}}</div>
            </div>
            <div class="col-span-12 tablet:col-span-4 laptop:col-span-3 desktop:col-span-3 p-6 border-l-1 border-neutral-100" *ngIf="status.referenceType === 'Personal'">
              <i class="fak fa-talos-user text-neutral-400 text-6"></i>
              <div class="mt-2 text-neutral-500 text-4">Candidate</div>
              <div class="mt-1 text-4 font-medium text-dark">{{status.applicantName}}</div>
            </div>
            <div class="col-span-12 tablet:col-span-4 laptop:col-span-3 desktop:col-span-3 p-6 border-l-1 border-neutral-100" *ngIf="status.referenceType === 'Personal'">
              <i class="fak fa-talos-calendar-alt text-neutral-400 text-6"></i>
              <div class="mt-2 text-neutral-500 text-4">Time known</div>
              <div class="mt-1 text-4 font-medium text-dark">{{status.timeKnown}}</div>
            </div>
            <div class="col-span-12 tablet:col-span-4 laptop:col-span-3 desktop:col-span-3 mobile-hide" *ngIf="status.referenceType === 'Personal'">&nbsp;</div>
            <div class="col-span-12 gap-4 tablet:col-span-12 laptop:col-span-3 desktop:col-span-3 p-6 mobile:pt-0 tablet:pt-0 desktop:pt-6 flex tablet:items-center tablet:justify-self-end desktop:justify-center">
              <div class="button-holder flex justify-start tablet:justify-self-end pt-4 tablet:pt-0">
                <button
                  class="rounded primary py-5 px-8 tablet:px-6 desktop:px-6 text-light primary flex items-center justify-center h-44 text-4"
                  id="lets-begin"
                  (click)="showRefereeForm()"
                  [disabled]="!isFormInitialised">
                  Let's Begin
                  <i class="fak fa-talos-arrow-right pl-2 text-4"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-span-12 tablet:col-span-12 py-8 px-9 bg-light rounded" *ngIf="status.referenceType === 'Personal'">
        <div class="tablet:flex">
          <div class="tablet:pr-6 flex-100">
            <img src="assets/protecting-icon.svg" alt="Protecting your information" class="mb-6"/>
          </div>
          <div>
            <p class="mb-2 text-4 font-medium text-dark">Protecting your information</p>
            <p class="mb-6 paragraph-1 text-neutral-500 text-4">We will always safeguard your personal information and any information which you share in relation to this reference, as set out in our <a href="/privacy-policy" target="_blank" class="text-4 info-200">Privacy Policy</a>.</p>
          </div>
        </div>
      </div>

      <div class="col-span-12 tablet:col-span-12 py-8 px-9 bg-light rounded" *ngIf="status.referenceType === 'Professional'">
        <div class="tablet:flex">
          <div class="tablet:pr-6 flex-100">
            <img src="assets/basic-reference-icon.svg" alt="Can’t provide a full reference?" class="mb-6 tablet:mb-0" />
          </div>
          <div>
            <p class="mb-2 text-4 font-medium text-dark">Can’t provide a full reference?</p>
            <p class="mb-6 paragraph-1 text-neutral-500 text-4 ">Is your company policy to only provide basic employment details? To save time uploading a document from your organisation, we’ve made it really simple to confirm all the required information.</p>
            <button
              class="flex items-center mt-1 group info-200 hover:info-200 text-4"
              id="show-basic-professional-form"
              (click)="showBasicProfessionalForm()">
              <span class="text-4"> Confirm basic details</span>
              <i class="fak fa-talos-arrow-right font-semibold ml-1 group-hover:ml-2 transition-all" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="col-span-12 tablet:col-span-6 py-8 px-9 bg-light rounded" *ngIf="status.referenceType === 'Professional'">
        <img src="assets/protecting-icon.svg" alt="Protecting your information" class="mb-6" />
        <p class="mb-2 text-4 font-medium text-dark">Protecting your information</p>
        <p class="mb-6 paragraph-1 text-neutral-500 text-4 ">We will always safeguard your personal information and any information which you share in relation to this reference, as set out in our <a href="/privacy-policy" target="_blank" class="text-4 info-200">Privacy Policy</a>.</p>
      </div>

      <div class="col-span-12 tablet:col-span-6 py-8 px-9 bg-light rounded" *ngIf="status.referenceType === 'Professional'">
        <img src="assets/did-you-know-icon.svg" alt="Did you know" class="mb-6" />
        <p class="mb-2 text-4 font-medium text-dark">Did you know...</p>
        <p class="mb-6 paragraph-1 text-neutral-500 text-4 ">Under GDPR regulations, the candidate has no right to view the refererence that you provide us with. You can rest assured that it will be treated as strictly confidential.</p>
        <a class="flex items-center mt-1 group info-200 hover:info-200 text-4" href="https://talos360.co.uk/resources/ats/hiring-tips/7-tips-to-make-recruitment-referencing-easy/" target="_blank"><span class="text-4"> Learn more</span><i class="fak fa-talos-arrow-right font-semibold ml-1 group-hover:ml-2 transition-all" aria-hidden="true"></i></a>
      </div>

      <div class="col-span-12 flex justify-center mb-12" *ngIf="status.clientEmail">
        <div class="grid grid-cols-1 tablet:grid-cols-2 py-3 bg-light rounded">
          <div class="flex items-center tablet:w-665 laptop:w-912 pl-2">
            <i class="fak fa-information text-info-200 text-9"></i>
            <p class="ml-2 mr-2 text-4 text-dark">If you are unable to supply any of the required information, please contact <a class="link text-4 text-info-200" [href]="'mailto:' + status.clientEmail" target="_blank">{{status.clientName}}</a>.
          </div>
        </div>
      </div>
    </div>


  </div>

  <div class="dashboard-container flex justify-center bg-light pt-8" *ngIf="showForm">
    <div class="border-b-1 border-neutral-100 mb-7 block w-343 tablet:w-665 laptop:w-912">
      <button
        class="w-44 h-44 border-1 border-neutral-200 bg-light rounded"
        id="form-back"
        (click)="showDashboard()">
        <i class="fa-solid fa-arrow-left text-4"></i>
      </button>
      <div
        [innerHTML]="formHtml | sanitiseHtml">
      </div>

      <div class="flex items-center mt-20 mb-7 rounded p-6 information-banner">
        <i class="fak fa-talos-information text-6 text-info-200"></i>
        <span class="caption-1 text-dark text-4 ml-4">
            Once you&#39;ve submitted this form {{status!.clientName}} will be notified of your reference. You don&#39;t have to do anything further.
        </span>
      </div>

    </div>
  </div>

  <div class="dashboard-container flex justify-center bg-light pb-8" *ngIf="showForm">
    <div class="flex w-343 tablet:w-655 laptop:w-912 items-center content-center self-center">
      <div class="w-343 tablet:w-665 laptop:w-912">
        <div class="flex items-center">
          <span class="caption-1 text-neutral-500 text-3">
            By submitting these details you are agreeing that you&#39;ve read our <a href="/privacy-policy" class="text-3 text-info-200" target="_blank">Privacy Policy</a> and confirming that we are able to store these details to process this reference check.
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="dashboard-container flex justify-center bg-light pb-8" *ngIf="showBasicForm && status">
    <div class="mb-7 w-343 tablet:w-665 laptop:w-912 pt-7">
      <button
        class="w-44 h-44 border-1 border-neutral-200 bg-light rounded"
        id="basic-form-back"
        (click)="showDashboard()">
        <i class="fa-solid fa-arrow-left text-4"></i>
      </button>
      <h1 class="font-medium">Confirm {{applicantFirstName}}’s basic details</h1>
      <p class="text-neutral-700 text-4 pb-9 mb-9 border-b-1 border-neutral-100 block">
        To save time uploading a document, we’ve made it really simple to confirm all the required information. Simply read the below, amend if necessary and then submit the form.
      </p>
      <div class="grid grid-cols-1 tablet:grid-cols-2 gap-5">
        <div>
          <label class="text-4 text-dark block" for="organisationName">Organisation Name</label>
          <input
            (input)="onOrganisationNameChange($event);"
            [value]="status.organisationName"
            name="organisationName"
            id="organisationName"
            type="text"
            [ngClass]="getFieldShowValidationMessage('organisationName') ? 'error border-error-500': ''"
            required
            class="textbox-field mt-2"/>
          <div *ngIf="getFieldShowValidationMessage('organisationName')" class="text-error-500 text-4 mt-2">
            Please enter the organisation name
          </div>
        </div>
        <div>
          <label class="text-4 text-dark block" for="applicantPosition">{{applicantFirstName}}’s position at the time</label>
          <input
            (input)="onApplicantPositionChange($event);"
            [value]="status.applicantPosition"
            name="applicantPosition"
            id="applicantPosition"
            type="text"
            [ngClass]="getFieldShowValidationMessage('applicantPosition') ? 'error border-error-500': ''"
            required
            class="textbox-field mt-2"/>
          <div *ngIf="getFieldShowValidationMessage('applicantPosition')" class="text-error-500 text-4 mt-2">
            Please enter the position of the applicant
          </div>
        </div>
        <div class="tablet:col-span-2">
          <p class="font-medium text-4 text-dark mt-5">Start date</p>
        </div>
        <div>
          <label class="text-4 text-dark block" for="startDateMonth">Month</label>
          <select
            (change)="onStartDateMonthChange($event);"
            name="startDateMonth"
            id="startDateMonth"
            class="dropdown-field block mt-2 w-full"
            required>
            <option
              *ngFor="let month of months; let i = index"
              class="dropdown-button text-left text-4 py-2 m-0"
              [value]="month"
              [id]="'start-month-' + i"
              [selected]="month === status.startDateMonth">
              {{monthToString(month)}}
            </option>
          </select>
          <div *ngIf="getFieldShowValidationMessage('startDateMonth')" class="text-error-500 text-4 mt-2">
            Please choose a month
          </div>
        </div>
        <div>
          <label class="text-4 text-dark block" for="startDateYear">Year</label>
          <select
            (change)="onStartDateYearChange($event);"
            name="startDateYear"
            id="startDateYear"
            class="dropdown-field block mt-2 w-full"
            required>
            <option
              *ngFor="let year of years; let i = index"
              class="dropdown-button text-left text-4 py-2 m-0"
              [id]="'start-year-' + i"
              [value]="year"
              [selected]="year === status.startDateYear">
              {{year}}
            </option>
          </select>
          <div *ngIf="getFieldShowValidationMessage('startDateYear')" class="text-error-500 text-4 mt-2">
            Please choose a year
          </div>
        </div>
        <div class="tablet:col-span-2">
          <p class="font-medium text-4 text-dark mt-5">End date</p>
        </div>
        <div>
          <label class="text-4 text-dark block" for="endDateMonth">Month</label>
          <select
            (change)="onEndDateMonthChange($event);"
            [disabled]="status.currentRole"
            [ngClass]="status.currentRole ? 'border-neutral-100 bg-neutral-50 text-neutral-400': ''"
            name="endDateMonth"
            id="endDateMonth"
            class="dropdown-field block mt-2 w-full">
            <option
              *ngFor="let month of months; let i = index"
              class="dropdown-button text-left text-4 py-2 m-0"
              [id]="'end-month-' + i"
              [value]="month"
              [selected]="month === status.endDateMonth">
              {{monthToString(month)}}
            </option>
          </select>
          <div *ngIf="getFieldShowValidationMessage('endDateMonth')" class="text-error-500 text-4 mt-2">
            Please choose a month
          </div>
        </div>
        <div>
          <label class="text-4 text-dark block" for="endDateYear">Year</label>
          <select
            (change)="onEndDateYearChange($event);"
            [disabled]="status.currentRole"
            [ngClass]="status.currentRole ? 'border-neutral-100 bg-neutral-50 text-neutral-400': ''"
            name="endDateYear"
            id="endDateYear"
            class="dropdown-field block mt-2 w-full">
            <option
              *ngFor="let year of years; let i = index"
              class="dropdown-button text-left text-4 py-2 m-0"
              [id]="'end-year-' + i"
              [value]="year"
              [selected]="year === status.endDateYear">
              {{year}}
            </option>
          </select>
          <div *ngIf="getFieldShowValidationMessage('endDateYear')" class="text-error-500 text-4 mt-2">
            Please choose a year
          </div>
        </div>
        <div class="tablet:col-span-2">
          <input type="checkbox"
            class="mr-2 check"
            [checked]="status.currentRole"
            name="currentRole"
            id="currentRole"
            (click)="onCurrentRoleChange($event);"
          />
          <label class="text-4 text-dark" for="currentRole">Current role</label>
        </div>
        <div class="mt-8">
          <label class="text-4 text-dark block" for="salary">Salary (optional)</label>
          <input
            (input)="onSalaryChange($event);"
            placeholder="Enter any salary information"
            name="salary"
            id="salary"
            type="text"
            required
            class="textbox-field mt-2"/>
        </div>
        <div class="tablet:col-span-2">
          <label class="text-4 text-dark block" for="otherInformation">Any other information you wish to share? (optional)</label>
          <textarea
            (input)="onOtherInformationChange($event);"
            name="otherInformation"
            id="otherInformation"
            class="textarea-field mt-2"
          ></textarea>
        </div>
      </div>
      <div class="pl-6 items-center bg-info-75 border-primary-100 border-1 flex tablet:col-span-2 py-4 tablet:py-0 rounded mt-9">
        <i class="fak fa-information text-6 text-info-200 mr-2"></i>
        <p class="text-3 text-dark py-5">Once you’ve submitted this form {{status.clientName}} will be notified of your reference. You don’t have to do anything further. </p>
      </div>
      <div class="flex flex-col items-end justify-end buttons-container mb-8">
        <button
          type="button"
          class="submit-button mt-4"
          id="submit-basic-form"
          (click)="submitBasicForm()">
            Submit
            <i id="submit-button-basic-icon" class="fak fa-talos-arrow-right ml-2"></i>
        </button>
        <div *ngIf="this.showValidation && form && form.status === 'INVALID'" class="text-error-500 text-4 mt-2 pt-0">
          Your form contains errors
        </div>
      </div>
      <p class="tablet:col-span-2 text-neutral-500 mt-7 pt-7 text-3 border-t-1 border-neutral-100">
        By submitting these details you are agreeing that you’ve read our <a href="/privacy-policy" class="text-info-200 text-3" target="_blank">Privacy Policy</a> and confirming that we are able to store these details to process this reference check.
      </p>
    </div>
  </div>
</div>
